import { get, post } from '../utils/httpClient';

const V4 = '/api/v1/admin';

async function json(res: Response) {
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// Assujetti
export async function getMyAssujetti(assujettiId?: string) {
  const q = assujettiId ? `?assujetti_id=${assujettiId}` : '';
  return json(await get(`${V4}/assujetti/me${q}`));
}

export async function getMyEstablishments(assujettiId?: string) {
  const q = assujettiId ? `?assujetti_id=${assujettiId}` : '';
  return json(await get(`${V4}/assujetti/me/establishments${q}`));
}

export async function getMyHistory(assujettiId?: string) {
  const q = assujettiId ? `?assujetti_id=${assujettiId}` : '';
  return json(await get(`${V4}/assujetti/me/history${q}`));
}

// Licenses
export async function getLicenseRules() {
  return json(await get(`${V4}/licenses/rules`));
}

export async function getEstablishmentLicenses(establishmentId: string) {
  return json(await get(`${V4}/licenses/establishments/${establishmentId}`));
}

export async function getRenewalCalendar(assujettiId?: string) {
  const q = assujettiId ? `?assujetti_id=${assujettiId}` : '';
  return json(await get(`${V4}/licenses/renewals/calendar${q}`));
}

export async function createRenewal(licenseId: string, notes?: string) {
  return json(await post(`${V4}/licenses/renewals`, { license_id: licenseId, notes }));
}

// FPT V4
export async function listDeclarations(params?: { assujetti_id?: string; period?: string }) {
  const sp = new URLSearchParams();
  if (params?.assujetti_id) sp.set('assujetti_id', params.assujetti_id);
  if (params?.period) sp.set('period', params.period);
  const q = sp.toString() ? `?${sp}` : '';
  return json(await get(`${V4}/fpt-v4/declarations${q}`));
}

export async function getDeclaration(id: string) {
  return json(await get(`${V4}/fpt-v4/declarations/${id}`));
}

export async function submitDeclaration(data: {
  establishment_id: string;
  period: string;
  amount_usd: number;
  amount_cdf: number;
  notes?: string;
}) {
  return json(await post(`${V4}/fpt-v4/declarations`, data));
}

export async function recordPayment(data: {
  declaration_id: string;
  amount: number;
  currency: string;
  reference: string;
  method: string;
}) {
  return json(await post(`${V4}/fpt-v4/payments`, data));
}

// Export CSV
export async function exportFptData(type: string, assujettiId?: string) {
  const sp = new URLSearchParams({ type, format: 'csv' });
  if (assujettiId) sp.set('assujetti_id', assujettiId);
  const res = await get(`${V4}/fpt-v4/export?${sp}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.blob();
}

// Upload justification
export async function uploadJustification(declarationId: string, file: File) {
  const fd = new FormData();
  fd.append('file', file);
  const { httpClient } = await import('../utils/httpClient');
  const res = await httpClient(`${V4}/fpt-v4/declarations/${declarationId}/justification`, {
    method: 'POST',
    body: fd,
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// Quittances (V4 wrapper)
export async function getQuittances(page = 1, pageSize = 25) {
  return json(await get(`/api/v1/fpt/quittances?page=${page}&page_size=${pageSize}`));
}

export async function downloadQuittancePdf(id: string): Promise<Blob> {
  const res = await get(`/api/v1/fpt/quittances/${id}/pdf`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.blob();
}
